import { mapGetters } from "vuex";

export default {
  name: "EplNewBackHeader",
  computed: {
    ...mapGetters(["bbpsImages", "serviceType"])
  },
  mounted() {
    if (!this.serviceType && this.$route.query) {
      this.$store.commit("serviceType", this.$route.query.type);
    }
    if (!this.bbpsImages.length) {
      this.$store.dispatch("quickLinksNewDashboard");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/EplNewBackHeader/component.js